import axiosInstance from './axios';

export const loadCauses = () =>{
    return new Promise((resolve, reject)=>{
        axiosInstance.get('/causes').then((resp)=>{
            resolve(resp.data)
        }).catch(()=>{
            resolve([])
        })
    });
}

export const loadSubCauses = (cause_id) => {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/causes/sub${cause_id ? `?causeId=${cause_id}` : ''}`).then((resp) => {
            resolve(resp.data);
        }).catch(() => {
            resolve([]);
        });
    });
};